import { render, staticRenderFns } from "./ProjectFilesView.vue?vue&type=template&id=0ba94cb9"
import script from "./ProjectFilesView.vue?vue&type=script&lang=ts"
export * from "./ProjectFilesView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports